export default __webpack_public_path__ + "static/TN-71025e952e3fccfaa8608232fd1dd8e2.pdf";